import type { PropertyFiltersUrlTarget } from '~/adapters/propertyFilters/propertyFiltersUrl';
import type { PropertyFilters } from '~/core/entities/property/filters';
import type { PageName } from '~/presenters/PropertyFiltersPresenter';
import type { RouteLocationRaw } from 'vue-router';

import { buildPropertyFiltersUrl } from '~/adapters/propertyFilters/propertyFiltersUrl';

export function targetFor(
	page: PageName = 'imoveis',
	collection?: string
): PropertyFiltersUrlTarget {
	if (page === 'colecao')
		return { kind: 'curatedCollection', slug: collection };
	if (page === 'colecoes') {
		if (!collection) return { kind: 'collectionRoot' };
		return collection === 'minha-colecao'
			? { kind: 'ownCollection' }
			: { kind: 'sharedCollection', slug: collection };
	}
	return { kind: 'listing', page };
}

export interface SearchUrlOptions {
	page?: PageName;
	collection?: string;
	query?: Parameters<typeof buildPropertyFiltersUrl>[0]['contextQuery'];
}

// The only place the search turns filters into an href.
export function buildSearchUrl(
	filters: Partial<PropertyFilters>,
	{ page, collection, query = {} }: SearchUrlOptions = {}
): string {
	return buildPropertyFiltersUrl({
		filters,
		target: targetFor(page, collection),
		contextQuery: query
	});
}

// Same href split for consumers that read `path` (breadcrumb JSON-LD).
export function buildSearchRoute(
	filters: Partial<PropertyFilters>,
	options?: SearchUrlOptions
): RouteLocationRaw {
	const [path, query] = buildSearchUrl(filters, options).split('?');
	return query
		? { path, query: Object.fromEntries(new URLSearchParams(query)) }
		: { path };
}
